
















































































































































import {
  defineComponent,
  ref,
  inject,
  computed,
  onMounted
} from '@vue/composition-api'
import { ConversationsApiKey, Conversation } from '@/rest/conversations-api'
import ApiLoader from '@/contexts/frontend/ApiLoader.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleRight,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCheck,
  faTimes
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCheck,
  faTimes
)

export default defineComponent({
  components: {
    ApiLoader
  },
  setup() {
    const conversations = ref([] as Array<Conversation>)
    const loading = ref<Promise<unknown>>(null)
    const conversationsApi = inject(ConversationsApiKey)
    const searchText = ref('')
    let currentSort = ref('title')
    let currentSortDirection = ref('asc')
    let pageSize = 15
    let currentPage = ref(1)

    onMounted(() => {
      loading.value = conversationsApi.ListConversations().then(response => {
        if (response?._tag == 'success') {
          conversations.value = response.data
        } else {
          console.error(response.error)
        }
      })
    })

    const conversationsFound = computed(() => conversations.value.length > 0)

    const sort = (column: string) => {
      if (column === currentSort.value)
        currentSortDirection.value =
          currentSortDirection.value === 'asc' ? 'desc' : 'asc'

      currentSort.value = column
    }

    const sortedConversations = computed(() => {
      return [...conversations.value]
        .sort((a, b) => {
          // sort alphabetically
          if (currentSortDirection.value === 'asc') {
            if (currentSort.value === 'id')
              return a[currentSort.value] - b[currentSort.value]
            else
              return a[currentSort.value]
                ? a[currentSort.value].localeCompare(b[currentSort.value])
                : -1
          } else {
            if (currentSort.value === 'id')
              return b[currentSort.value] - a[currentSort.value]
            return a[currentSort.value]
              ? a[currentSort.value].localeCompare(b[currentSort.value]) * -1
              : -1
          }
        })
        .filter(conversation => {
          // search filter
          const id = conversation.id.toString()
          const date = conversationDate(conversation.date).toString()
          const titlesLC = conversation.title.toLowerCase()
          const projectsLC = (
            conversation.project_display_name ?? 'Not Set'
          ).toLowerCase()
          const teamsLC = (
            conversation.team_display_name ?? 'Not Set'
          ).toLowerCase()
          const usersLC = (
            conversation.owner_display_name ?? 'Not Set'
          ).toLowerCase()
          const statusLC = conversation.status.toString().toLowerCase()
          return (
            id.includes(searchText.value) ||
            date.includes(searchText.value) ||
            titlesLC.includes(searchText.value) ||
            projectsLC.includes(searchText.value) ||
            teamsLC.includes(searchText.value) ||
            usersLC.includes(searchText.value) ||
            statusLC.includes(searchText.value)
          )
        })
        .filter((row, index) => {
          // pagination filter
          let start = (currentPage.value - 1) * pageSize
          let end = currentPage.value * pageSize
          if (index >= start && index < end) return true
        })
    })

    const firstPage = () => {
      currentPage.value = 1
    }

    const lastPage = () => {
      currentPage.value = Math.ceil(conversations.value.length / 10)
    }

    const nextPage = () => {
      if (currentPage.value * pageSize < conversations.value.length)
        currentPage.value++
    }

    const prevPage = () => {
      if (currentPage.value > 1) currentPage.value--
    }

    const conversationDate = (date: string) =>
      new Date(date).toLocaleDateString('en-GB')

    return {
      conversations,
      loading,
      conversationsFound,
      searchText,
      sort,
      sortedConversations,
      firstPage,
      lastPage,
      nextPage,
      prevPage,
      conversationDate
    }
  }
})
